import React from 'react';
import { colorSet } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => {
  return {
    root: {
      width: 230,
      borderRadius: 10,
      backgroundColor: colorSet.gray000
    },
    header: {
      borderRadius: '10px 10px 0px 0px',
      padding: '10px 16px',
      color: colorSet.gray000,
      backgroundColor: colorSet.primary500
    },
    contentWrapper: {
      padding: 16
    },
    content: {
      paddingTop: 16,
      borderTop: `1px solid ${colorSet.gray200}`
    },
    wordBreak: {
      wordBreak: 'break-all',
      '& b': {
        wordBreak: 'break-all'
      }
    },
    footer: {
      padding: 16
    }
  };
});

const RfqQuotationRegisterRequestBubble = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <CustomizedTypography variant="body2" fontWeight="bold" color="inherit">
          견적서
        </CustomizedTypography>
      </div>
      <div className={classes.contentWrapper}>
        <CustomizedTypography
          variant="body1"
          fontWeight="bold"
          gutterBottoms={10}
        >
          견적서 발행요청
        </CustomizedTypography>
        <CustomizedTypography variant="body2" className={classes.wordBreak}>
          파트너에게 견적서 발행요청을 전송하였습니다.
        </CustomizedTypography>
      </div>
    </div>
  );
};

export default RfqQuotationRegisterRequestBubble;
